import { RouteObject } from 'react-router';

import { Navigate } from 'react-router-dom';
import Authenticated from 'src/components/Authenticated';

import AccentSidebarLayout from 'src/layouts/AccentSidebarLayout';
import BaseLayout from 'src/layouts/BaseLayout';

import { Suspense, lazy } from 'react';
import SuspenseLoader from 'src/components/SuspenseLoader';
import accountRoutes from './account';
import BannerDataRoutesAdmin from './admin-routes/Banner';
import contentRoutesAdmin from './admin-routes/Content';
import adminDashboardsRoutes from './admin-routes/dashboards';
import leadRoutesAdmin from './admin-routes/lead';
import adminManagementRoutes from './admin-routes/management';
import masterDataRoutesAdmin from './admin-routes/masterData';
import packagesRoutesAdmin from './admin-routes/packages';
import reviewRatingRoutesAdmin from './admin-routes/reviewRating';
import baseRoutes from './base';
import vendorDashboardRoutes from './vendor-routes/dashboards';
import leadRoutesVendor from './vendor-routes/lead';
import vendorManagementRoutes from './vendor-routes/management';
import packagesRoutes from './vendor-routes/packages';

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

const VendorDetails = Loader(
  lazy(() => import('src/content/vendor-content/vendor-details'))
);

const ReferralManagement = Loader(
  lazy(() => import('src/content/commons/ReferralManagement'))
);

const SystemConfig = Loader(
  lazy(() => import('src/content/admin-content/system-config'))
);

const SosAlerts = Loader(
  lazy(() => import('src/content/commons/SosAlerts'))
);

let userType = localStorage.getItem('userType');

// Listen for storage events
window.addEventListener('storage', function (event) {
  // Check if the event is for the specific key you're interested in
  if (event.key === 'userType') {
    // Handle the change here
    // For example, update the authentication status in the current tab
    updateAuthenticationStatus();
  }
});

// Function to update authentication status in the current tab
export function updateAuthenticationStatus() {
  userType = localStorage.getItem('userType');
  // Update authentication status in the current tab based on the value
}

const router: RouteObject[] = [
  {
    path: 'account',
    children: accountRoutes
  },
  {
    path: '',
    element: <BaseLayout />,
    children: baseRoutes
  },

  // Admin Routes
  userType === '"TCA"' && {
    path: 'admin/dashboard',
    element: (
      <Authenticated>
        <AccentSidebarLayout />
      </Authenticated>
    ),
    children: [
      {
        path: '',
        element: <Navigate to="home" replace />
      },
      {
        path: 'home',
        children: adminDashboardsRoutes
      },
      {
        path: 'management',
        children: adminManagementRoutes
      },
      {
        path: 'referrals',
        element: <ReferralManagement />
      },
      {
        path: 'master',
        children: masterDataRoutesAdmin
      },
      {
        path: 'banner',
        children: BannerDataRoutesAdmin
      },
      {
        path: 'package',
        children: packagesRoutesAdmin
      },
      {
        path: 'lead-management',
        children: leadRoutesAdmin
      },

      {
        path: 'review-rating-management',
        children: reviewRatingRoutesAdmin
      },
      {
        path: 'content-management',
        children: contentRoutesAdmin
      },
      {
        path: 'system-config',
        element: <SystemConfig />
      },
      {
        path: 'sos-alerts',
        element: <SosAlerts />
      }
    ]
  },
  // Vendor Routes
  userType === '"TCV"' && {
    path: 'vendor/dashboard',
    element: (
      <Authenticated>
        <AccentSidebarLayout />
      </Authenticated>
    ),
    children: [
      {
        path: '',
        element: <Navigate to="home" replace />
      },
      {
        path: 'home',
        children: vendorDashboardRoutes
      },
      {
        path: 'referrals',
        element: <ReferralManagement />
      },
      {
        path: 'management',
        children: vendorManagementRoutes
      },
      {
        path: 'package',
        children: packagesRoutes
      },
      {
        path: 'lead-management',
        children: leadRoutesVendor
      },
      {
        path: 'business-profile',
        element: <VendorDetails />
      },
      {
        path: 'sos-alerts',
        element: <SosAlerts />
      }
    ]
  }
];

export default router;
